import { Component, HostBinding, TemplateRef } from '@angular/core';

import { ToastService } from './toast.service';

@Component({
    selector: 'app-toasts',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
})
export class ToastComponent {
    @HostBinding('class.ngb-toasts') toasts = true;

    autohide = true;

    constructor(public toastService: ToastService) {}

    isTemplate(toast) {
        return toast.textOrTpl instanceof TemplateRef;
    }
}
